/**
 * Case where multiple `?tab=details` were accidentally saved
 * Case was fixed, and this function prevents future incidents
 */
const normalizeTab = (tab) => {
  if (typeof tab !== "string") return tab;

  // Extract only the part after the last `?tab=`
  const match = tab.match(/(?:\?tab=)([^?]*)$/);
  return match ? `${match[1]}` : tab;
};

export default normalizeTab;
